module.exports = __webpack_public_path__ + "static/img/T240319.1a12fc3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/T240319.png
// module id = I6WJ
// module chunks = 41